import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import { Sizes, Typography } from '@ratehub/base-ui';
import { ContributionLimitTFSACalculator } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import AdvertisingDisclosure from './AdvertisingDisclosure';


function BankingContributionLimitTFSACalc({
    disclaimer,
    showAdDisclosure,
    className,

    ...otherProps
}) {
    return (
        <Container className={className}>
            <ContributionLimitTFSACalculator
                {...otherProps}
            />

            <If condition={disclaimer}>
                <p className={
                    classNames(
                        Typography.CLASSES.TEXT_XS,
                        'disclaimer',
                    )}
                >
                    {disclaimer}
                </p>
            </If>

            <If condition={showAdDisclosure}>
                <AdvertisingDisclosure
                    className="rh-display-block rh-mt-1 rh-ml-auto"
                    size="extra-small"
                />
            </If>
        </Container>
    );
}

BankingContributionLimitTFSACalc.propTypes = {
    showAdDisclosure: PropTypes.bool,
    disclaimer: PropTypes.string,
    className: PropTypes.string,
};

BankingContributionLimitTFSACalc.defaultProps = {
    showAdDisclosure: undefined,
    disclaimer: undefined,
    className: undefined,
};

const CONTAINER_MAX_WIDTH = '50rem';

const Container = styled.section`
    padding: ${Sizes.SPACING.HALF} 0;
    max-width: ${CONTAINER_MAX_WIDTH};
    margin: 0 auto;

    > .disclaimer {
        margin: 0;
        text-align: center;

        padding-top: ${Sizes.SPACING.HALF};
    }
`;

BankingContributionLimitTFSACalc.blockKey = 'rh/banking-contribution-limit-tfsa-calculator';
BankingContributionLimitTFSACalc.requiresLayoutRow = true;
BankingContributionLimitTFSACalc.hasHeading = false;
BankingContributionLimitTFSACalc.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsBanking ];

export default BankingContributionLimitTFSACalc;
